// extracted by mini-css-extract-plugin
module.exports =  {"currencyContainer":"InvoicesTable_currencyContainer__KLHDB","tablePaymentScheduleDetail":"InvoicesTable_tablePaymentScheduleDetail__MBl2R"};